import {IPresentationMeta} from '../incase-domain/presentation';
import {PLAYER_HOST, PLAYER_PRES_ID_QUERY, PLAYER_ROOM_ID_QUERY, PRESENTER_CODE_QUERY} from '../incase-domain/online';
import {ProtectionType} from '../incase-domain/presentationProtection';

export function isPresentationRunnable(protectionType: ProtectionType[] | undefined): boolean {
    const runnableProtections = [
        ProtectionType.GUEST,
        ProtectionType.PASSWORD,
        ProtectionType.REGISTERED_USERS,
        ProtectionType.SELECTED_USERS,
        ProtectionType.AAI_EDU,
        ProtectionType.EMEDIKUS,
        ProtectionType.ZOOM,
    ];

    if (!protectionType) {
        return false;
    }

    return runnableProtections.some((type) => protectionType.includes(type));
}

export const createPlayPresentationUrl = (
    presentation: IPresentationMeta,
    isCustom?: boolean,
    roomId?: string,
    isRoomAdmin?: boolean,
    slideId?: string,
    presenterCode?: string
): string => {
    let url = '';
    if (roomId) {
        url = `${PLAYER_HOST}?${PLAYER_ROOM_ID_QUERY}=${roomId}`;
    } else {
        url = `${PLAYER_HOST}?${PLAYER_PRES_ID_QUERY}=${presentation._id}`;
    }

    if (isRoomAdmin) {
        url += `&roomAdmin=${isRoomAdmin}`;
    }

    if (presenterCode) {
        url += `&${PRESENTER_CODE_QUERY}=${presenterCode}`;
    }

    if (slideId) {
        url += `&slideId=${slideId}`;
    }

    // case when admin is opening presentation that requires request params
    if (presentation.requestParams) {
        presentation.requestParams.forEach((param) => {
            if (isCustom && param.required && !param.value) {
                throw new Error(`Missing required request param: ${param.key}`);
            } else if (isCustom && param.value) {
                url += `&${param.key}=${param.value}`;
            } else if (!isCustom) {
                url += `&${param.key}=ADMIN`;
            }
        });
        return url;
    }
    return url;
};
